<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>基础管理->角色管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="roleName" placeholder="角色名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                </div>
            </div>

             <el-table
                ref="table"
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55px"  :selectable="selectable"></el-table-column>
                <el-table-column type="index" label="序号" width="55px" :index="indexMethod"> </el-table-column>
                <el-table-column prop="roleName" label="角色名" width="150px">
                </el-table-column>
                <el-table-column prop="authoritys" label="权限" :show-overflow-tooltip="true" width="250px">
                </el-table-column>
                <el-table-column prop="commonName" label="拥有该权限人" :show-overflow-tooltip="true" width="200px">
                </el-table-column>
                <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120px">
                    <template slot-scope="scope">
                        <el-button 
                            @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button 
                            @click.native.prevent="setUser(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">分配</span>
                        </el-button>
                        <el-button style="color: red" :disabled="scope.row.roleType == 0"
                            @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>

        <!-- 新增/修改弹出框 -->
        <el-dialog :title="tval==1?'新增':'修改'" :close-on-click-modal="false" :visible.sync="editVisible" :before-close="dialogClose" width="30%">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item prop="roleName" label="角色名">
                    <el-input v-model="form.roleName" maxlength="100"></el-input>
                </el-form-item> 

                <el-form-item prop="remark" label="备注">
                    <el-input type="textarea" v-model="form.remark" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item prop="remark" label="菜单权限" style="height:230px;">
                    <el-scrollbar style="height:230px;">
                        <el-tree
                            :data="menuData"
                            ref="rootTree"
                            show-checkbox
                            node-key="id"
                            :default-checked-keys="defaultCheckedKeys"
                            :props="defaultProps">
                        </el-tree>
                    </el-scrollbar>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>
        </el-dialog>

        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="delVisible" width="300px" center>
            <div class="del-dialog-cnt">删除不可恢复，是否确定删除？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delVisible = false">取消</el-button>
                <el-button type="primary" @click="del">确定</el-button>
            </span>
        </el-dialog>
        <!-- 新增/修改弹出框 -->
        <div v-if="setUserVisible">
            <setUser ref="setUser"></setUser>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import setUser from './SetUser.vue';

    export default {
        name:"Role",
        data(){
            return{
                tval:1,
                editVisible: false,
                delVisible: false,
                setUserVisible: false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                roleName:"",
                form:{
                    id:"",
                    roleName:"",
                    remark:"",
                    deptId:""
                },
                rules: {
                    roleName: [
                        { required: true, message: '请输入角色名', trigger: 'blur' }
                    ]
                },
                depts:[],
                data:[],
                menuData:[],              
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                defaultCheckedKeys:[]
            }
        },
        components: {
            setUser
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.roleUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    roleName:this.roleName,
                    deptId:this.form.deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.roles;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增界面
            setAdd(){
                this.tval=1;
                this.form.id="";
                this.form.roleName="";
                this.form.remark="";
                this.editVisible=true;
                this.defaultCheckedKeys=[];
                this.getTree();
            },
            //修改界面
            setUpdate(val){
                this.tval=2;
                let url  = this.getRoleUrl;
                let data = {
                    id:val.id
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data.roleDo));
                    if(res.status==200){
                        this.editVisible=true; 
                        this.form.id=res.data.roleDo.id;
                        this.form.roleName=res.data.roleDo.roleName;
                        this.form.remark=res.data.roleDo.remark;
                        this.getTree();
                        // console.log(res.data.roleDo.authoritys);
                        if( res.data.roleDo.authoritys!=null &&
                            res.data.roleDo.authoritys.length>0 ){
                            this.defaultCheckedKeys=res.data.roleDo.authoritys.split(",");
                        }else{
                            this.defaultCheckedKeys=[];
                        };
                        
                        if (this.$refs['form'] != undefined) {
                            this.$refs['form'].validate((valid) => {});
                        }

                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getTree(){
                let url  = this.roleGetTreeUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.menuData = res.data.tree; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //保存
            save(){
               this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url="";
                        if(this.tval==1){
                            url = this.roleAddUrl;
                        }else if(this.tval==2){
                            url = this.roleUpdateUrl;
                        }
                        let data = {
                            id:this.form.id,
                            deptId:this.form.deptId,
                            roleName:this.form.roleName,
                            remark:this.form.remark,
                            authoritys:this.$refs.rootTree.getCheckedKeys()
                        };
                        // console.log("保存值："+JSON.stringify(data))
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.editVisible=false;
                                this.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.roleDelUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            //批量删除管理员
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            },
            // 分配
            setUser(data){
                this.setUserVisible=true;
                this.$nextTick(() => {
                    this.$refs['setUser'].init(data);
                })
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/page/sys/role/Role.vue